module.exports = "<app-introduction></app-introduction>\n<app-portfolio></app-portfolio>\n<app-contact></app-contact>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-page/main-page.component.html
// module id = ./src/app/main-page/main-page.component.html
// module chunks = main